import SubscriptionStats from "../models/subscriptionStats";
import httpService from "./httpService";

const apiEndpoint = "/subscriptions";

const getSubscriptionStats = (idSubscription: number) => {
  return httpService.get<SubscriptionStats>(
    `${apiEndpoint}/getSubscriptionStats?idSubscription=${idSubscription}`
  );
};

const subscriptionService = {
  getSubscriptionStats,
};

export default subscriptionService;
